<template>
  <img class="mascot" src="../assets/guildguardian-logo.png" alt="GuildGuardian Logo">
</template>

<script>
export default {
  name: 'MascotLogo'
}
</script>
